import { createSlice } from "@reduxjs/toolkit";

const initialStateValue = "";

export const loggedEmployee = createSlice({
	name: "loggedEmployee",
	initialState: {
		value: initialStateValue,
	},
	reducers: {
		setloggedEmployeerReducer: (state, action) => {
			state.value = action.payload;
		},
		clearloggedEmployeeReducer: (state) => {
			state.value = initialStateValue;
		},
	},
});

export const { setloggedEmployeerReducer, clearloggedEmployeeReducer } = loggedEmployee.actions;
export default loggedEmployee.reducer;